import { updateCurrUser } from "../actions/auth";
import { setLastFilterId } from "../actions/projects";
import { storeIsFilterSaved } from "../actions/task";
import { label } from "../config";
import { route } from "../config/routes";
import { getTeamSavedFilter, updateLastTeamFilter } from "../shared/services/projects.service";

/**
 * Persists the user's last saved filter for a project, switches to Grid, and
 * navigates to Tasks **without** a `/:sharedFilterId` URL segment (personal
 * filters are not shareable). `TeamFilterSetter` picks up `lastFilterId` from
 * the backend on mount.
 *
 * @param {object} p
 * @param {import("redux").Dispatch} p.dispatch
 * @param {{ push: (path: string) => void }} p.history
 * @param {object} p.user - `state.auth.user` (needs `myProjectId` for personal-board URL)
 * @param {string|number} p.filterId
 * @param {string|number} p.projectId - project scope for `updateLastTeamFilter`
 * @param {string} [p.projectName] - team URL segment (raw name from API is fine)
 * @param {boolean} [p.isPersonalBoard] - when true, navigates to `/tasks` only
 */
export async function openFavoriteFilterInTasksGrid({ dispatch, history, user, filterId, projectId, projectName, isPersonalBoard }) {
  if (filterId == null || filterId === "" || projectId == null || projectId === "") return;

  await dispatch(updateLastTeamFilter(projectId, filterId));
  await dispatch(getTeamSavedFilter({ projectId }));
  dispatch(setLastFilterId(filterId));
  dispatch(storeIsFilterSaved(true));
  dispatch(updateCurrUser({ lastSelectedBoard: label.GRID }));
  const tasksUrl =
    isPersonalBoard || (user?.myProjectId != null && String(projectId) === String(user.myProjectId))
      ? route.PRIVATE_ROUTE.TASKS.PATH
      : `${route.PRIVATE_ROUTE.TASKS.PATH}/${projectId}/${encodeURIComponent(String(projectName ?? ""))}`;

  history.push(tasksUrl);
}
